import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Card from "antd/es/card";
import cn from "classnames";
import { Textfit } from "react-textfit";

import styles from "./MetricCard.module.scss";

interface Props {
  alignment?: "center" | "left" | "right";
  average?: React.ReactNode;
  className?: string;
  icon?: IconProp;
  onClick?: () => void;
  title: React.ReactNode;
  type?: "error" | "info" | "success";
  value: React.ReactNode;
}

const MetricCard: React.FC<Props> = ({
  alignment = "center",
  average,
  className,
  onClick,
  title,
  type,
  value,
}) => {
  return (
    <Card
      bordered={false}
      className={cn(
        styles.container,
        styles[`ta-${alignment}`],
        {
          [styles.clickable]: !!onClick,
          [styles.error]: type === "error",
          [styles.info]: type === "info",
          [styles.success]: type === "success",
        },
        className
      )}
      onClick={onClick}
    >
      <Textfit className={styles.value} max={48} mode="single">
        {value}
      </Textfit>
      <div className={styles.title}>{title}</div>
      {average && <div className={styles.average}>{average}</div>}
    </Card>
  );
};

export default MetricCard;
